import { render } from "./Cloze.vue?vue&type=template&id=64a0d330&scoped=true"
import script from "./Cloze.vue?vue&type=script&lang=js"
export * from "./Cloze.vue?vue&type=script&lang=js"

import "./Cloze.vue?vue&type=style&index=0&id=64a0d330&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64a0d330"

export default script